import React from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import Search from "./Search";

interface ToolbarWithAddProps {
  searchQuery: string;
  onSearchQueryChange: (q: string) => void;
  onAddClick?: () => void;
  addLabel?: string;
  showAddIcon?: boolean;
}

const ToolbarWithAdd: React.FC<ToolbarWithAddProps> = ({
  searchQuery,
  onSearchQueryChange,
  onAddClick,
  addLabel = "Add Template",
  showAddIcon = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "flex-start" : "space-between",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 1.25 : 2,
        p: 2,
        backgroundColor: "transparent",
        borderBottom: "1px solid #E5E7EB",
        borderRadius: 0,
        mb: 0,
      }}
    >
     <Box sx={{ width: "100%", flex: isMobile ? "0 0 auto" : "1 1 auto" }}>
        <Search
          value={searchQuery}
          onChange={onSearchQueryChange}
          fullWidth={isMobile}
          size={isMobile ? "small" : "medium"}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {onAddClick && (
         <Button
          variant="contained"
          onClick={onAddClick}
          startIcon={showAddIcon ? <AddIcon fontSize={isMobile ? "small" : "medium"} /> : undefined}
          fullWidth={isMobile}                                 
          sx={{
            textTransform: "none",
            bgcolor: "#9BCB4A",
            "&:hover": { bgcolor: "#88B33F" },
            height: isMobile ? 38 : 40,
            fontSize: isMobile ? 13 : 15,
            borderRadius: 2,
            minWidth: { xs: 160, sm: 180, md: 150 },      
            whiteSpace: "normal",                            
            lineHeight: 1.15,
            textAlign: "center",
          }}
        >
          {addLabel}
        </Button>

        )}
      </Box>
    </Box>
  );
};

export default ToolbarWithAdd;
